import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Button } from "antd";
import { useDispatch } from "react-redux";
import {addCategory, updateCategory} from "../../../../store/slices/categoriesSlice";
import {useTranslation} from "react-i18next";

const { Option } = Select;

const CategoryModal = ({ isVisible, onClose, category }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const isEditing = !!category;

    useEffect(() => {
        if (isEditing) {
            form.setFieldsValue({
                title: category.title,
                description: category.description
            }); // Pre-fill form when editing
        } else {
            form.resetFields(); // Reset form when adding
        }
    }, [category, form]);

    // Handle submit
    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            if (isEditing) {
                await dispatch(updateCategory({ id: category.id, updatedData: values, t:t})); // Edit mode
            } else {
                await dispatch(addCategory({newCategory: values, t:t})); // Add mode
                form.resetFields();
            }
            onClose(); // Close modal
        } catch (error) {
            console.error(t("validation.failed"), error);
        }
    };

    return (
        <Modal title={isEditing ? t("category.edit.modal") : t("category.add.modal")} open={isVisible} onCancel={onClose} footer={null}>
            <Form form={form} layout="vertical">
                <Form.Item label={t("title")} name="title" rules={[{ required: true, message: t("message.pleaseEnterTitle")}]}>
                    <Input placeholder={t("enter.title")}/>
                </Form.Item>
                <Form.Item label={t("category.description")} name="description" rules={[{ required: false}]}>
                    <Input placeholder={t("enter.description")}/>
                </Form.Item>
                <Button type="primary" onClick={handleSubmit} block>
                    {isEditing ? t("edit") : t("add")}
                </Button>
            </Form>
        </Modal>
    );
};

export default CategoryModal;